<script setup>
import { Inertia } from '@inertiajs/inertia'

import EditModelValues from '@/Components/Models/Organisation/EditModelValues.vue';

const props = defineProps({
	organisation: {
		type: Object,
		required: true
	},
	user: {
		type: Object,
		required: true
	},
	app: {
		type: Object,
		required: true
	},
})

const emit = defineEmits([
	'update:organisations'
])

function save() {
	emit('update:organisations', props.organisation)
}

function back(){
	Inertia.visit('/organisations/' + props.organisation.id);
}
</script>

<template>
	<form @submit.prevent="save" class="w-full">
		<SectionCard title="Editing Member Organisation">
			<template #default>
				<EditModelValues
					:organisation="organisation"
					:errors="organisation.errors"
					:app="app"
					:user="user"
					@update:organisation="save"
				/>
			</template>

			<template #footer>
				<Button @click="back" type="button" class="mr-1">Back</Button>
				<Button @click="save" color="blue">Save</Button>
			</template>
		</SectionCard>
	</form>
</template>